export function tryParse(data) {
    if (typeof data === 'string') {
        try {
            return JSON.parse(data);
        }
        catch (e) {
            /* Ignore */
        }
    }
    return data;
}
//# sourceMappingURL=experiments-data-utils.js.map